import { Flex } from "antd";
import { FC } from "react";

import { PrimaryText, SecondaryText } from "@/shared/ui/Typography";

import { StyledSSRow } from "./Styled";

interface SequentialScaleProps {
    minComplete: number;
    maxComplete: number | null;
}

export const SequentialScale: FC<SequentialScaleProps> = ({
    minComplete,
    maxComplete,
}) => {
    const maxCompleteValue = maxComplete === null ? "∞" : `${maxComplete} %`;

    return (
        <Flex vertical gap={24}>
            <PrimaryText>
                Послідовний розрахунок — це система нарахування бонусів, в якій
                коефіцієнт зростання послідовно збільшується від мінімального до
                максимального відсотку виконання плану.
            </PrimaryText>

            <Flex vertical gap={12}>
                {[
                    { label: "Зараховується від:", value: `${minComplete} %` },
                    { label: "Зараховується до:", value: maxCompleteValue },
                ].map(({ label, value }) => (
                    <StyledSSRow key={label}>
                        <SecondaryText>{label}</SecondaryText>

                        <PrimaryText fontWeight="500">{value}</PrimaryText>
                    </StyledSSRow>
                ))}
            </Flex>
        </Flex>
    );
};
